let $ = require("jquery");



export default function jqueryValidationSoftCheck(validator, element, options={}){
  return jqueryElementFunc.call(validator, element, options);
}


function jqueryValidationSoftChecker(element, options={}){
  if(options.$){
    $ = options.$;
  }

  element = this.validationTargetFor( this.clean( element ) );

  var rules = $( element ).rules(),
    rulesCount = $.map( rules, function( n, i ) {
      return i;
    } ).length,
    dependencyMismatch = false,
    val = this.elementValue( element ),
    result, method, rule;

  // If a normalizer is defined for this element, then
  // call it to retreive the changed value instead
  // of using the real one.
  // Note that `this` in the normalizer is `element`.
  if ( typeof rules.normalizer === "function" ) {
    val = rules.normalizer.call( element, val );

    if ( typeof val !== "string" ) {
      throw new TypeError( "The normalizer should return a string value." );
    }

    // Delete the normalizer from rules to avoid treating
    // it as a pre-defined method.
    delete rules.normalizer;
  }

  for ( method in rules ) {
    rule = { method: method, parameters: rules[ method ] };

    result = $.validator.methods[ method ].call( this, val, element, rule.parameters );

    // If a method indicates that the field is optional and therefore valid,
    // don't mark it as valid when there are no other rules
    if ( result === "dependency-mismatch" && rulesCount === 1 ) {
      dependencyMismatch = true;
      continue;
    }
    dependencyMismatch = false;

    if ( result === "pending" ) {
      // this.toHide = this.toHide.not( this.errorsFor( element ) );
      return;
    }

    if ( !result ) {
      // THIS IS WERE JQUERY  VALIDATION
      // MESSED UP, WE NEED A FUNCTION JUST LIKE
      // THIS ONE, BUT THAT IS A PURE FUNCTION,
      // NOT A MUTATING ONE
      // this.formatAndAdd( element, rule );
      return false;
    }
  }
  return true;
}





function jqueryElementFunc( element, options={} ) {
      var cleanElement = this.clean( element ),
        checkElement = this.validationTargetFor( cleanElement ),
        v = this,
        result = true,
        rs, group;

      if( checkElement === undefined ){
        // delete this.invalid[ cleanElement.name ];
      } 
      else{
        // this.prepareElement( checkElement );

        // If this element is grouped, then validate all group elements already
        // containing a value
        group = this.groups[ checkElement.name ];
        if ( group ) {
          $.each( this.groups, function( name, testgroup ) {
            if ( testgroup === group && name !== checkElement.name ) {
              cleanElement = v.validationTargetFor( v.clean( v.findByName( name ) ) );
              if ( cleanElement && cleanElement.name in v.invalid ) {
                // v.currentElements.push( cleanElement );
                result = jqueryValidationSoftChecker.call(v, cleanElement, options) && result;
              }
            }
          } );
        }

        rs = jqueryValidationSoftChecker.call(v, checkElement, options ) !== false;
        result = result && rs;
      }
      
      return !!result;
    }


// WEBPACK FOOTER //
// ./src/components/QuickWizard/additions.js